import React, { Component } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import { Space, Radio,message, Spin } from "antd";
import Bridge from "../../../utils/Bridge";
import { logEvent } from "../../../utils/analytics";

export default class AlsFrsr extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:false,
      field_data:[],
      speech:"",
      salivation:"",
      swallowing:"",
      handwriting:"",
      participant_uses_gastronomy:"",
      cutting_food_a:"",
      cutting_food_b:"",
      dressing_and_hygine:"",
      turning_bed:"",
      walking:"",
      climbing_stairs:"",
      dyspnea:"",
      orthopnea:"",
      respiratory_insufficiency:"",
      questions:{
        cutting_food_a:[],
        cutting_food_b:[],
      },
      field_data:[]
    };
  }
  /**
   * Calls get_alsfrs_details when component mounts
   */
  componentDidMount() {
    this.get_alsfrs_details()
  }
  get_alsfrs_details=()=>{
    this.setState({loading:true})
    let params = "?participants_accounts_id=" + localStorage.getItem("ap_participants_accounts_id")+'&type=form';
    Bridge.participants.speech.alsfrs
    .list(params)
    .then((response) => {
      if (response.status == "1") {
        
        const fromSpeechSession =
          new URLSearchParams(window.location.search).get("from") ===
          "speech-session";
        if (response.data.is_alsfrs_present == true && !fromSpeechSession) {
          window.location.assign('/update-alsfrs-and-roads')
          return
        }
        let list=response.data.alsfrs_questions
        const uniquefields = [...new Map(list.map(item => [item.field, item])).values()];
        let alsfrs_questions_arr=[];
        for(let item of uniquefields){
          let arr=list.filter(i=>i.field==item.field);
          let options=arr.map(i=>({
            label:i.description,
            value:i.values,
          }))
          alsfrs_questions_arr.push({
            field:item.field,
            options:options,
            field_label:item.field_label,
            // item: item,
            view_name: item.view_name,
            state_name:"",
            value:""
          })
        }
        let new_arr=[]
        let cutting_food_a_questions=[]
        let cutting_food_b_questions=[]
        for(let item of alsfrs_questions_arr){
          if(item.field=='SPEECH_FTORRES'){
            item.state_name='speech';
          }
          if(item.field=='SALIVA_FTORRES'){
            item.state_name='salivation';
          }
          if(item.field=='SWALLOW_FTORRES'){
            item.state_name='swallowing';
          }
          if(item.field=='HNDWRIT_FTORRES'){
            item.state_name='handwriting';
          }
          if(item.field=='GASTRO_FTORRES'){
            item.state_name='participant_uses_gastronomy';
          }
          if(item.field=='UTENWOG_FTORRES'){
            item.state_name='cutting_food_a';
            cutting_food_a_questions=item.options
          }
          if(item.field=='UTENWG_FTORRES'){
            item.state_name='cutting_food_b';
            cutting_food_b_questions=item.options
          }
          if(item.field=='HYGIENE_FTORRES'){
            item.state_name='dressing_and_hygine';
          }
          if(item.field=='BEDCLOTH_FTORRES'){
            item.state_name='turning_bed';
          }
          if(item.field=='WALKING_FTORRES'){
            item.state_name='walking';
          }
          if(item.field=='STAIRS_FTORRES'){
            item.state_name='climbing_stairs';
          }
          if(item.field=='DYSPNEA_FTORRES'){
            item.state_name='dyspnea';
          }
          if(item.field=='ORTHO_FTORRES'){
            item.state_name='orthopnea';
          }
          if(item.field=='RESPINS_FTORRES'){
            item.state_name='respiratory_insufficiency';
          }
          new_arr.push(item)
        }
        this.setState({
          questions:{
            cutting_food_a:cutting_food_a_questions,
            cutting_food_b:cutting_food_b_questions,
          },
          field_data: new_arr,
          // questions: new_arr,
          loading:false
        })
      }else{
        this.setState({loading:false})
      }
    })
    .catch((error) => {
      this.setState({ loading: false });
    });
  }
  save_details=()=>{
    if (!this.state.speech) {
      message.warning("Please select Speech value");
      return;
    }
    if (!this.state.salivation) {
      message.warning("Please select Salivation value");
      return;
    }
    if (!this.state.swallowing) {
      message.warning("Please select Swallowing value");
      return;
    }
    if (!this.state.handwriting) {
      message.warning("Please select Handwriting value");
      return;
    }
    if (!this.state.participant_uses_gastronomy) {
      message.warning("Please select 'Participant uses gastronomy' value");
      return;
    }
    if (this.state.cutting_food_a=="" && this.state.cutting_food_b=="") {
      message.warning(
        "Please select 'Cutting food and handling utensils' value"
      );
      return;
    }
    if (!this.state.dressing_and_hygine) {
      message.warning("Please select Dressing and hygiene value");
      return;
    }
    if (!this.state.turning_bed) {
      message.warning("Please select Turning bed value");
      return;
    }
    if (!this.state.walking) {
      message.warning("Please select Walking value");
      return;
    }
    if (!this.state.climbing_stairs) {
      message.warning("Please select Climbing stairs value");
      return;
    }
    if (!this.state.dyspnea) {
      message.warning("Please select Dyspnea value");
      return;
    }
    if (!this.state.orthopnea) {
      message.warning("Please select Orthopnea value");
      return;
    }
    if (!this.state.respiratory_insufficiency) {
      message.warning("Please select Respiratory insufficiency value");
      return;
    }
    
    let field_data=this.state.field_data
    const uniqueNames = [...new Map(field_data.map(item => [item.field, item])).values()];
    let questions=[]
    for(let item of uniqueNames){
      if(item.field=='SPEECH_FTORRES'){
        let obj={
          value:this.state.speech,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='SALIVA_FTORRES'){
        let obj={
          value:this.state.salivation,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='SWALLOW_FTORRES'){
        let obj={
          value:this.state.swallowing,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='HNDWRIT_FTORRES'){
        let obj={
          value:this.state.handwriting,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='GASTRO_FTORRES'){
        let obj={
          value:this.state.participant_uses_gastronomy,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='UTENWOG_FTORRES'){
        let obj={
          value:this.state.cutting_food_a,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='UTENWG_FTORRES'){
        let obj={
          value:this.state.cutting_food_b,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='HYGIENE_FTORRES'){
        let obj={
          value:this.state.dressing_and_hygine,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='BEDCLOTH_FTORRES'){
        let obj={
          value:this.state.turning_bed,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='WALKING_FTORRES'){
        let obj={
          value:this.state.walking,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='STAIRS_FTORRES'){
        let obj={
          value:this.state.climbing_stairs,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='DYSPNEA_FTORRES'){
        let obj={
          value:this.state.dyspnea,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='ORTHO_FTORRES'){
        let obj={
          value:this.state.orthopnea,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      if(item.field=='RESPINS_FTORRES'){
        let obj={
          value:this.state.respiratory_insufficiency,
          view_name:item.view_name,
          form:"ALSFRS-R",
          field: item.field
        }
        questions.push(obj)
      }
      
    }
    let params = {
      data: JSON.stringify(questions),
      participants_accounts_id:localStorage.getItem("ap_participants_accounts_id")
    };
    this.setState({ loading: true });
    Bridge.participants.speech.alsfrs
    .save_alsfrs(params)
      .then((response) => {
        this.setState({ loading: false });
        if (response.status == "1") {
          logEvent("form_submitted", { form_name: "alsfrs_r" });
          message.success(response.message);
          this.setState(
            {
              loading: false,
            },
            () => {
              setTimeout(() => {
                window.location.assign("/update-alsfrs-and-roads");
              }, 3000);
            }
          );
        } else {
          message.error(response.message);
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }
  render() {
    return (
      <div>
        <Header />
        <div className="main-content demographics-section-wrapper">
          <div className="container">
            <div className="row">
              <div className="col-lg-11 m-auto">
                <div className="demographic-single-section">
                  <a
                    href={
                      new URLSearchParams(window.location.search).get(
                        "from"
                      ) === "speech-session"
                        ? "/my-personal-data-viewer"
                        : "/dashboard"
                    }
                    className="back-arrow"
                  >
                    <box-icon
                      name="chevron-left"
                      color="#fff"
                      style={{ position: "relative", top: 1 }}
                    ></box-icon>
                    {new URLSearchParams(window.location.search).get(
                      "from"
                    ) === "speech-session"
                      ? "Back"
                      : "Dashboard"}
                  </a>
                  <div>
                    <div className="header">
                      <h3 className="text-uppercase">ALSFRS-R</h3>
                      <div className="white-block"></div>
                    </div>
                    <div className="form-fields">
                      <Spin spinning={this.state.loading}>
                        <div>
                          
                          {this.state.field_data.map((item,index)=>{
                            if(item.field=='SPEECH_FTORRES'||item.field=='SALIVA_FTORRES'||item.field=='SWALLOW_FTORRES'||item.field=='HNDWRIT_FTORRES'){
                              return (
                                <div className="form-group" key={index}>
                                  <label className="input-heading">
                                    {item.field_label}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        [item.state_name]: e.target.value,
                                      })
                                    }
                                    value={this.state[item.state_name]}
                                    direction={item.status_name=='participant_uses_gastronomy' ? 'horizontal' : 'vertical'}
                                  >
                                    <Space direction="vertical">
                                      {item.options.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              )
                            }
                          })}

                          <div className="form-group">
                            <label className="input-heading">
                            Participant uses a gastrostomy for greater than 50% of nutrition:{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <br />
                            <Radio.Group
                              onChange={(e) =>
                                this.setState({
                                  participant_uses_gastronomy: e.target.value,
                                  cutting_food_a:"",
                                  cutting_food_b:""
                                })
                              }
                              value={this.state.participant_uses_gastronomy}
                              direction="horizontal"
                            >
                              <Space direction="horizontal">
                                <Radio value={1}>Yes</Radio>
                                <Radio value={2}>No</Radio>
                              </Space>
                            </Radio.Group>
                          </div>
                          
                          {this.state.participant_uses_gastronomy && (
                            <>
                              {this.state.participant_uses_gastronomy=='1'? (
                                <div className="form-group">
                                  <label className="input-heading">
                                    5b. Cutting Food and Handling Utensils (alternate scale for participants with gastrostomy):{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        cutting_food_b: e.target.value,
                                      })
                                    }
                                    value={this.state.cutting_food_b}
                                    direction="vertical"
                                  >
                                    <Space direction="vertical">
                                      {this.state.questions.cutting_food_b.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              ):(
                                <div className="form-group">
                                  <label className="input-heading">
                                  5a. Cutting Food and Handling Utensils (participants without gastrostomy):{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        cutting_food_a: e.target.value,
                                      })
                                    }
                                    value={this.state.cutting_food_a}
                                    direction="vertical"
                                  >
                                    <Space direction="vertical">
                                      {this.state.questions.cutting_food_a.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              )}
                            </>
                          )}

                          {this.state.field_data.map((item,index)=>{
                            if(['HYGIENE_FTORRES','BEDCLOTH_FTORRES','WALKING_FTORRES','STAIRS_FTORRES','DYSPNEA_FTORRES','ORTHO_FTORRES','RESPINS_FTORRES'].includes(item.field)){
                              return (
                                <div className="form-group" key={index}>
                                  <label className="input-heading">
                                    {item.field_label}{" "}
                                    <span className="text-danger">*</span>
                                  </label>
                                  <br />
                                  <Radio.Group
                                    onChange={(e) =>
                                      this.setState({
                                        [item.state_name]: e.target.value,
                                      })
                                    }
                                    value={this.state[item.state_name]}
                                    direction="vertical"
                                  >
                                    <Space direction="vertical">
                                      {item.options.map((single,i)=>{
                                        return (<Radio value={single.value}>{single.label}</Radio>)
                                      })}
                                    </Space>
                                  </Radio.Group>
                                </div>
                              )
                            }
                          })}
                          <button
                            className="submit-button"
                            style={{ padding: "9px 15px 10px 20px" }}
                            onClick={() => this.save_details()}
                          >
                            <box-icon
                              name="save"
                              type="solid"
                              color="#fff"
                              size={'17px'}
                              style={{ position: 'relative', top: -1, left: -11 }}
                            ></box-icon>
                            Save{" "}
                          </button>
                        </div>
                      </Spin>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
